const generalActions = {
  GENERAL_STATE_PROP_SET: 'GENERAL_STATE_PROP_SET'
};

export default generalActions;